import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const ShopByHeaderSection = t0 => {
  const $ = _c(9);
  const {
    children,
    label,
    labelClassName: t1
  } = t0;
  const labelClassName = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames("flex flex-col mb-4 md:mr-8", "last:mr-0", "max-[767px]:[&+&]:[border-top:1px_solid_#f1f1f1] max-[767px]:[&+&]:mt-[1.3rem] max-[767px]:[&+&]:pt-[1.3rem]");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = `text-xs font-bold text-[#74777a] mb-2 max-[767px]:text-base max-[767px]:font-bold max-[767px]:text-gray ${labelClassName}`;
  let t4;
  if ($[1] !== label || $[2] !== t3) {
    t4 = <h3 className={t3}>{label}</h3>;
    $[1] = label;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children) {
    t5 = <div className="items-center flex min-h-[46px]">{children}</div>;
    $[4] = children;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <div className={t2}>{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
ShopByHeaderSection.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  labelClassName: PropTypes.string
};
export default ShopByHeaderSection;